import React from 'react';
import { useRef, useState, forwardRef } from 'react';
import './../css/Contact.css';
import MessageMe from './MessageMe';
import emailjs from 'emailjs-com';

const Contact = forwardRef((props,ref) => {
    const [name,setName] = useState('');
    const [email,setEmail] = useState('');
    const [message,setMessage] = useState('');
    const [error,setError] = useState('');
    const [success,setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const nameInput = useRef(null);
    const emailInput = useRef(null);
    const messageInput = useRef(null);
    const formRef = useRef();

    const sendMessage = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if((name==='')||(email==='')||(message==='')) {
            setError('Please fill all fields!');
            return;
        }
        setLoading(true);
        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            formRef.current,
            process.env.REACT_APP_EMAILJS_USER_ID
        ).then(
            (result) => {
                setName('');
                setEmail('');
                setMessage('');
                setSuccess('Thanks for your message! I will get back to you soon!');
                setError('');
                setLoading(false);
                nameInput.current.value = '';
                emailInput.current.value = '';
                messageInput.current.value = '';
            },
            (error) => {
                setError('Sorry. Something went wrong. Please try again later.');
                setLoading(false);
            }
        );
    }
    const [vis,setVis] = useState(0);
    const handleScroll = () => {
        if(ref.current !== null)
        {
            var pixelsScrolled = (window.pageYOffset - ref.current.offsetTop + window.innerHeight);
            var compHeight = ref.current.clientHeight;
            var percentScrolled = (pixelsScrolled/compHeight)*100;
            if(percentScrolled<40 && vis!==0) setVis(0);
            if(percentScrolled>=40 && vis!==1) setVis(1);
        }
    }
    window.addEventListener('scroll', handleScroll);
    return (
        <div className='contactOuter' ref={ref}>
            <div className='container contact'>
                <h1 className="mainHeading">LET'S TALK</h1>
                <div className="gridCon">
                    <div className={ (vis===1) ? "gridConImg gridConImgAnimate" : "gridConImg"}>
                        <MessageMe />
                    </div>
                    <div className={ (vis===1) ? "gridConDesc gridConDescAnimate" : "gridConDesc" }>
                        <p>Want to discuss about your new project? Just leave me a message and I will get back to you!</p>
                        <form className="contactForm" ref={formRef} onSubmit={sendMessage} autoComplete="off">
                            {
                                (error!=='') && 
                                <div className="contactFormInput">
                                    <p style={{ color: 'orange' }}>{error}</p>
                                </div>
                            }
                            {
                                (success!=='') && 
                                <div className="contactFormInput">
                                    <p style={{ color: '#99ffcc' }}>{success}</p>
                                </div>
                            }
                            <div className="contactFormInput">
                                <label htmlFor="contactName">Your Name</label>
                                <input type="text" id='contactName' name='from_name' placeholder='Enter Full Name'
                                onChange={ (e) => { setName(e.target.value) }} ref={nameInput} />
                            </div>
                            <div className="contactFormInput">
                                <label htmlFor="contactEmail">Your Email</label>
                                <input type="email" id='contactEmail' name='reply_to' placeholder='Enter Email' 
                                onChange={ (e) => { setEmail(e.target.value) }} ref={emailInput} />
                            </div>
                            <div className="contactFormInput">
                                <label htmlFor="contactMessage">Your Message</label>
                                <textarea name="message" id="contactMessage" placeholder='Your message here'
                                onChange={ (e) => { setMessage(e.target.value) }} ref={messageInput} ></textarea>
                            </div>
                            <div className="contactFormInput">
                                <button className='btn' type="submit" disabled={loading}>
                                    {loading ? 'Sending...' : <><i className="fas fa-paper-plane"></i> Send Message</>}
                                </button>
                            </div>
                        </form>
                        <div style={{marginTop: '1.5rem', textAlign: 'center'}}>
                            <a className="hireMeBtn" href="https://wa.me/3139092278" target="_blank" rel="noopener noreferrer">💼 Hire Me on WhatsApp</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default Contact
